import { useTranslation } from 'react-i18next';
import EmptyIcon from '@/shared/assets/empty-icon.svg?react';

export const WebApiTokensContentEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="w-[6.4rem] h-[6.4rem] flex items-center justify-center text-foreground mb-[2.8rem]">
        <EmptyIcon className="w-[6.4rem] h-[6.4rem]" />
      </div>

      <p className="headline4 text-primary text-center mb-[0.8rem]">
        {t('webApiTokens.emptyState.title')}
      </p>

      <p className="p4 text-secondary text-center w-[30rem]">
        {t('webApiTokens.emptyState.description')}
      </p>
    </div>
  );
};
